import { Link, useLocation } from "react-router-dom";

/**
 * Farmhouse footer — kept quiet so it never fights the storybook.
 * Shows a subtle copyright + legal links on every page. On the Welcome
 * page we render only a minimal, unobtrusive © line so the barn-doors
 * reveal isn't disturbed.
 */
export default function Footer() {
  const { pathname } = useLocation();
  const isWelcome = pathname === "/";
  const year = new Date().getFullYear();

  if (isWelcome) {
    return (
      <div
        data-testid="site-footer"
        className="fixed bottom-2 left-1/2 -translate-x-1/2 z-40 pointer-events-none select-none"
      >
        <p
          className="text-[10px] tracking-[0.35em] uppercase text-[#F5EDDE]/80"
          style={{ textShadow: "0 1px 3px rgba(0,0,0,0.6)" }}
        >
          © {year} The Salty Moo™
        </p>
      </div>
    );
  }

  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 mt-0 border-t border-[#E7DFD5] bg-[#F3EBDD]/70"
    >
      <div className="max-w-4xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-script text-xl text-[#4B3A2F]">
          Where Faith Finds Its Salt.
        </p>
        <nav
          aria-label="Site legal"
          className="flex items-center gap-5 text-xs uppercase tracking-[0.25em] text-[#6D5A50]"
        >
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[#4B3A2F] transition-colors"
          >
            Privacy
          </Link>
          <span aria-hidden className="text-[#C8A876]">·</span>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[#4B3A2F] transition-colors"
          >
            Terms
          </Link>
        </nav>
        <p
          data-testid="site-copyright"
          className="text-xs text-[#6D5A50] font-body"
        >
          © {year} The Salty Moo™
        </p>
      </div>
    </footer>
  );
}
